import type { ReactNode } from 'react';

import { List, Alert, ListItem, Typography } from '@mui/material';

import { Iconify } from 'src/components/iconify';

type SetupGuideAlertProps = {
  title: string;
  steps: ReactNode[];
};

export function SetupGuideAlert({ title, steps }: SetupGuideAlertProps) {
  return (
    <Alert
      severity="info"
      icon={<Iconify icon="mdi:information" />}
      sx={{
        backgroundColor: '#e1f5fe',
        '& .MuiAlert-message': { width: '100%' },
      }}
    >
      <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
        {title}
      </Typography>
      <List dense sx={{ py: 0 }}>
        {steps.map((step, index) => (
          <ListItem key={index} sx={{ alignItems: 'flex-start', px: 0, py: 0.5 }}>
            <Iconify icon="mdi:circle-small" sx={{ color: 'primary.main', mt: 0.25, mr: 1 }} />
            <Typography variant="body2" color="text.primary">
              {step}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Alert>
  );
}
